export default class CommonMessage {

  static Success = 'Success';
  static Error = 'Error';
  static Warning = 'Warning';
  static Info = 'Info';
  static Confirm = 'Confirm';
  static Yes = 'Yes';
  static No = 'No';
  static Cancel = 'Cancel'
  static Close = 'Close'
  static SuccessOperation = 'Operation Completed Successfully';
  static ErrorOperation = 'Operation Completed With Error';
  static InfoOperation = 'Info Operation';
  static WarningOperation = 'Operation Completed With Warnings';
  static Loading = 'Loading ...';
  static ServerSideErrorHappended = 'Server Side Error Happended'
  static UnknownErrorHappened = 'Unknown Error Happened';
  static AdressNotFound = 'Adress Not Found';
  static ModelIsNotValid = 'Model Is Not Valid';

}